export default {
  // header
  "Hello,": '你好，',
  "Login": "登录",
  "Register": "注册",
  'Profile': '个人主页',
  'Test Results': '答题记录',
  'Wrong Bookmark': '错题收藏',
  'Settings': '系统设置',
  'Logout': '退出系统',
  'Download': '软件下载',
  'IELTS': '雅思',
  'TOEFL': '托福',
  'Home': '首页',
  'Download': '软件下载',
  'VIP': 'VIP会员',  
  'Active VIP': '激活VIP',

  'officialExam': '官方公开真题',
  'allFree': '全部免费',
  'undisclosedExam': '在考真题',
  'partlyFree': '部分免费',


  // headertwo
  'TOEFL Home': '托福首页',
  'Exam Mock': '套题模考',
  'Reading': '阅读',
  'Listening': '听力',
  'Speaking': '口语',
  'Writing': '写作',
  'Search': '搜索',
  'TPO All Free': 'TPO1-75 & 5套真题',
  'Sections Together': '听说读写一起模考',
  'Reading Section Free': '34 套阅读真题免费',
  'Section': '单项练习',
  'Articles Get Score': '2篇文章练习/模考.完成后出分',
  'SequentialHome': '顺序练习',
  'SingleArticles': '单篇文章练习',
  'TopicExercise': '题材练习 | 考频练习',
  'No duplication In_Exam with Out_Exam': '套题外真题:与套题内真题不重复',
  '5 Records Get Score': '5个录音 完成后出分',
  'Single Record': '单个录音练习',
  '4 Question': '4 个题目一起练习',
  'Single Question': '单个题目练习',
  '题材分类-单个题目练习': '题材分类-单个题目练习',
  'TPO_In_Exam': '套题内TPO', 
  'TPO_Out_Exam': '套题外TPO', 
  'toeflTPO': '托福TPO',
  'Undis_In_Exam': '套题内真题',
  'Undis_Out_Exam': '套题外真题',
  '4 Question Writing': '2个题目练习|模考',
  'Undisclosed': '在考真题套题',
  '': '',
  '': '',
  //GRE headertwo
  'GRE Home': 'GRE首页',
  'Chinese': "语文",
  'Maths': '数学',
  "写作.语文.数学一起模考": "写作.语文.数学一起模考",
  "disclosed All Free": "所有官方真题免费",
  //index

  'In_Exam_tpo': '完整TPO套题',
  'Out_Exam_tpo': '套题外TPO', 

  'In_Exam': '完整套题真题',
  'Out_Exam': '套题外真题',
  'Topic order': '顺序-单篇文章练习',
  'Topic classification': '题材分类-单篇文章练习',
  '2014-2015 Free': '2014-2015免费',
  'TPO Exam': 'TPO真题',
  'oforq': '官方公开的退役真题.TPO 1-75全部免费',
  'ieaoa': '完整套题TPO 与 套题外TPO 题目不重复',
  'ieaond': '完整套题真题 与 套题外真题 题目不重复',
  'eiiitt': '完整套题中套卷模考与单项练习中的题目完全重复.根据需要选择不同的练习方式',
  'completeSet': '套题内TPO',
  'outOfSetT': '套题外TPO',
  'View Details': '查看详情',
  'Fully simulated exams': '100%完全模拟考试场景',
  'Interface Exactly the same': '界面,倒计时,大小完全一致',

  'dotrq': '真题说明',
  'aqafre': '全部出自在考真题,特殊渠道获取.',
  'far': '2021-2024完全适配23年7月改革.',
  'itlaw': '包含最新的学术写作.',
  'sqaf': '部分真题免费.',
  'affvm': 'VIP会员全部免费.',
  'uem': 'VIP会员详情',
  'Officially open retired questions.TPO1-75 are all free': '官方公开的退役真题.TPO1-75全部免费',
  'Index d1': '自2023年7月26日起.托福考试迎来全新改革.改革后托福考试时间将由原来的3小时缩短至2小时.除了口语单项保持不变外,阅读,听力,写作三个单项的考试内容和时间均有变动. 其中其中TPO1-63为2019年改革前的题,TPO64-75为2019年改革后真题.知学君已对题库做了调整.移除了多余的一篇文章重新组成一个新的套题外单项.',
  'Index d2': ' ',
  'Index d3': ' ',
  'Index d4': '',
  'Start Exams': 'TPO套题模考',
  'Reform Summary': '改革详情',
  'Entire Set': '单项练习/模考',
  'Complete set of exercises': '单项练习/模考',
  'Score out': '5个录音练习/模考.出分',
  'Single Article Exercise': '顺序-单篇文章练习',
  'single recording exercise': '题材分类-单个录音练习',
  'exercises/mock exams': '2个题目练习/模考',
  'single Question Exercise': '话题分类-单个题目练习',

  'tpoExam': 'TPO套题',
  'TPOReading': 'TPO阅读',
  'TPOListening': 'TPO听力',
  'TPOSpeaking': 'TPO口语',
  'TPOWriting': 'TPO写作',
  "3 Articles Get Score": '2篇文章一起练习/模考出分',
  'Topicclassification': '题材分类-单篇文章练习',
  "4Questions": "4个题目练习|模考",
  "2Questions": "2个题目练习|模考",
  "Classification": "顺序-单个题目练习",
  "topicclassification": "话题分类-单个题目练习",
  'Records.GetScore': '5/6个录音练习/模考出分',
  // 'Index d3': ' 该练习材料全部出自在考真题，是ETS未公开开练习素材.通过特殊渠道获取。听力,口语,写作都是适应改革后的题库.阅读20年往后都是改革的试题.10个题/篇,2014-2019还是是14题/篇.没有适应新政.因为真题比较宝贵,没有删除多余的题目,',
  // 'Index d4': '其中2014-2015年阅读真题免。',
  'Index d5': '查看与TPO的区别',
  'Index d6': '在考真题套题模考',
  'Index d7': '该练习材料全部出自在考真题，是ETS未公开开练习素材.通过特殊渠道获取。阅读.听力,口语,写作都是适应改革后的题库.',
  'Index d8': '其中2014-2015年阅读真题免费',
  'Undisclosed Exam': '在考真题',
  'ouispf': '官方未公开的在考真题.通过特殊渠道获取.部分真题免费',

  'ReadingZT': '阅读真题',
  'ListeningZT': '听力真题',
  'SpeakingZT': '口语真题',
  'WritingZT': '写作真题',
  '整套练习/模考': '整套练习/模考',
  'Topic Out Exam': '套题外题目',
  'Topic': '题材练习',
  '4个题目练习/模考': "4个题目练习/模考",
  'exam': '真题套题',
  //gre index
  "公开套题": "公开套题",
  "Verbal": "Verbal",
  "Verbal Reasoning": "Verbal Reasoning",
  "Secction Mock/Pratic": "Secction练习/模考",
  "Reading&Logic": "阅读与逻辑",
  "Quantitative Reasoning": "Quantitative Reasoning",
  "题型练习": "题型练习",
  "套题模考": "套题模考",
  "多个/单个 根据题目类型练习": "多个/单个 根据题目类型练习",
  "知识点练习": "知识点练习",
  "多个/单个 知识点练习": "多个/单个 知识点练习",
  "一起模考.模拟考试场景": '一起模考.模拟考试场景',
  "Analytical Writing": "Analytical Writing",
  "lssue练习": "lssue练习",
  "Issue单个题目练习": "Issue单个题目练习",
  "Argument": "Argument练习",
  "Argument-单个题目练习": "Argument-单个题目练习",
  "2个写作题目": "2个写作题目",
  "2/3个Verbal": "2/3个Verbal",
  "2/3个Quantitative": "2/3个Quantitative",
  "Entire Set": "单项练习/模考",
  "Secction练习/模考": "Secction练习/模考",
  "2/3个Quantitative练习/模考": "2/3个Quantitative练习/模考",
  "1个Verbal练习/模考": "1 个Verbal练习/模考",
  "多篇/单篇文章练习": "多篇/单篇文章练习",
  "Equivalenc and Filling in the blanks": "等价与填空",
  "多个/单个题目练习": "多个/单个题目练习",
  "Quantitative": "Quantitative",
  'Officially open retired questions.free': '｜官方公开的退役真题.全部免费',
  "OfficialInstructions": "官方公开材料说明",
  "Material description": "材料说明",
  'GRE complete set contains': 'GRE完整套题包含',
  'GRE Index d1': '1.官方指南中配套的4套题.',
  'GRE Index d2': '2.官方在线模考软件中:提供了2套仿真系统，这2套系统中共包含了5套完整的GRE的题目，官方叫做Power Pop Online，简称PPO.',
  'GRE Index d3': '3.Power PlusOnline简称PPO plus.包含了三套官方真题',
  'GRE Index d4': '4.PP2: PP2其实是 prep的本地软件.',
  'SectionNote': "注意",
  'SectionNoteInfo': "以上都是GRE官方正式出版的套题.都是2015年以前的题.虽然是官方风格,但是与2020年以及的考试题在风格上还是有一些细微的区别,不会在未来的考试当中重复出现。所以上述的套题可以作为备考的补充材料",
  "Description": "说明",
  "DescriptionInfo": "GRE写作题库是公开的.每年有微更新.每次考试从公开题库中抽取.所有题库整理到下面的在考真里面.",
  "completeSet": "完整套题真题",
  "outOfSet": "套题外真题",
  "chargeSectionDescription": "该练习材料全部出自在考真题.通过特殊渠道获取.全部是2020年以后的真实考试题库中的套题.很大概率在以后的考试中再次考到.",
  //browe
  'Download Record': '下载录音',
  'RepeatDate': "重复时间",
  'Script': "翻译",
  'Note': "备忘",
  'Favorite': "收藏",
  'Report': "测试报告",
  //'Speaking':"口语题目",
  'Hide Answer': "隐藏答案",
  'Show Answer': "显示答案",
  'Answer': "答案",
  'Time': "时间",
  'History': "历史",
  'Article Explanation': "文章讲解",
  'Question Explanation': "题目讲解",
  'Browe d1': "此解析可拖动.方便看解析",
  'Reset': "复位",
  'QR code': "二维码",
  'Avatar': "头像",
  'Mentor Name': "导师名字",

  //testReport

  /*********exam-TPO-GRE**********/
  'Enter Exam': '进入试题',
  'Average website score': '网站平均得分',
  'Score': '分',
  'Exam INSTRUCTION': '模考说明  INSTRUCTION',
  'Hide': '隐藏说明>>',
  'Show': '展开说明>>',
  'TPO&Undisclosed&&In_Exam&Out_exam Description': 'TPO&真题&套题内&套题外说明',
  'Exam d1': "自2023年7月26日起.托福考试迎来全新改革.改革后托福考试时间将由原来的3小时缩短至2小时.除了口语单项保持不变外,阅读,听力,写作三个单项的考试内容和时间均有变动. 其中其中TPO1-63为2019年改革前的试题,TPO64-75为2019年改革后真题.其中TPO1-75已经通过调整适应23年后的改革.官方发布的23年后的试题更新中...... ",
  'GRE Exam INSTRUCTION': '模考说明  套题模考:全仿真还原考试环境',
  //listening vue


  //footer
  'About Us': '关于知学君',
  'Contact': '联系我们',
  'Cooperation': '市场合作',
  'Help': '使用帮助',
  'Links': '友情链接',
  'Website Version': '版权所有 知学君 京ICP备16042710号-1 Copyright ©2017',



  //button
  'original button': 'original',
  'trans button': 'trans',
  'explain button': 'explain',
  'replay button': 'replay',
  'flag button': 'flag',
  'note button': 'note',
  'locate button': 'locate',
  'dict button': 'dict',
  'report button': 'report',



  //sign up
  'User Agreement': '用户协议',
  'User Privacy Policy': '用户隐私政策',
  "receive message": '输入您的电话号码接受短信.回复"HELP"寻求帮助.回复"STOP"取消',
  "Sign up": "注册账号",
  "Log in": "登录账号",
  "I agree to receive text message": "我同意接受短信",
  'I have read and agree to': '我已阅读并接收',
  'Get verification code': '获取验证码',
  'seconds to re-acquire': '秒后重新获取',
  'Refresh': '看不清换一张',
  'Forgot password?': '忘记密码?',
  'Reset2': '立即重置',
  'The phone you entered is incorrect': '您输入的手机号不正确',
  'CAPTCHA': '图片验证码',
  'Enter the full mobile phone number to get the picture verification code': '输入完整手机号获取图片验证码',
  'And': '和',
  'Return to the homepage': '返回知学君首页',
  'Save': '保存',
  'Password reset successfully': '密码重置成功',
  'Reset password': '重置密码',
  'Mobile phone verification code': '手机验证码',
  'Please enter the login password': '请输入登录密码',
  'Please enter the invitation code': '请输入邀请码',
  'official account': '公众号',
  'zhixuejunred': '知学君',
  'Follow to avoid losing contact': '关注.防失联',
  "customer service WeChat": "客服微信",
  'Current': '当前',
  'registration. Login is only available to some users': '注册/登录仅对部分用户开放',
  'Dear user': '亲爱的用户',
  'You can add the customer service WeChat to get an invitation code. Registration is free': '你可以添加客服微信获取邀请码.免费注册',
  'Additional instructions': '其他说明',
  'Follow the Official  AccountsPlatform.The site may not be accessible': '请务必关注公众号.因为特殊原因会导致网站无法访问.',
  'You can contact us via whatsapp': '可以通过QQ18449511 QQ942951199 联系我们',
  'Contact us via email  b120346@163.com': '可以发送邮件到 b120346@163.com 联系我们',
  'Verification code error': '验证码错误',
  'Please enter the password': '请输入密码',
  'The verification code has been sent successfully, please check your messages.': "验证码发送成功，请注意查收短信。",
  'Please agree to the Terms of Service and Privacy Policy first.': '请先同意服务条款和隐私政策。',
  'Please enter the picture verification code': '请输入图片验证码',
  'The password must be 4-12 characters long': '请输入4-12位',
  'Please re-enter the password': '请再次输入密码',
  "The passwords entered do not match": "两次输入密码不一致",

  // vip
  'yanv': '亲爱的用户:',
  'Only shows': '您不是VIP会员',
  'odpqb': '当前仅显示部分题库.',
  'View VIP': 'VIP会员',
  'Membership Privileges': '与普通会员的区别?',
  'Become VlP member': '开通VIP会员',
  '': '',

  'buyNow': '立即购买',
  'freeTrial': '免费试用',
  'vipinfo1': '上百套在考真题.非TPO.适配23年改革样式',
  'vipinfo2': '完美模拟考试.界面功能一样',
  'vipinfo3': '套题.单项.题材 多种练习方式',

  'cmb': '会员权益对比',
  'xys': '小意思&知学君 选择更合适自己的',
  'why': '为什么',
  'cz': '选择知学君',
  'lqbf': '题库功能列表',
  'faq': '常见问题',

  'xiaoyisi': '小意思',
  'zhixuejunred': '知学君',

  'free': '免费版',
  'daoFree': '￥0',

  'freePay': '付费版',
  'daoFreePay': '￥239',

  'permanent': '永久使用',

  'esis': '在考真题套题',
  'Actual Reading': '阅读真题',
  'Actual Listening': '听力真题',
  'Actual Speaking': '口语真题',
  'Actual Writing': '写作真题',
  '': '',
  '': '',
  '': '',
  '': '',
  '': '',
  '': '',
  'set': '5套',
  'set41': '79套',
  'set75': '75套',
  'section45': '45套',
  'section5': '5套',
  'section75': '75 套',
  'section92': '141 套',
  'section99': '128 套',
  'section84': '122 套',
  'section185': '257 套',
  'section41': '41套',
  'year2020': '2014年-2020年',
  'year2024': '2014年-2024年',
  'QuestionPeriod': '题库时间',
  'nsu': '不定期更新',

  'pr': '套题模考 完美复刻',
  'ibs': '界面/按钮/流程跟考试一样 沉浸式模考',
  'taimof': '录音调试界面模拟官方功能',
  'raibjlte': '阅读文章图标/按钮/文章图片高仿',
  'rpaslte': '听力部分:录音播放/答题界面/倒计时界面一致',
  'oarjlte': '口语答题:录音跟考试一样',
  'wfijlt': '写作答题:功能界面跟考试一样.',

  'mpm': '多种练习模式',
  'estp': '套题模考 单项模考 题材练习',
  'e4pme': '套题模考:听说读写4个单项 完美模拟考试',
  'smise': '单项模考 单项练习',
  'teoare': '话题练习 题材练习',

  'peo': '功能强大 体验极佳',
  'bnwqe': '收藏/备忘/跳题/跳录音/原文/错题等',
  'ycbtayr': '可以收藏文章,题目,录音等',
  'ncbtatr': '可以添加备忘, 可以跳题,跳录音',
  'mccwqao': '会员中心: 收藏,错题等功能',
  'qadr': '题目解析,范文,示范录音',


  'faqTitle1': '什么是在考真题?跟TPO与机经有什么区别?',
  'faqAnswer1': '(1)在考真题:服役中的考试题库 TPO:退役的真题，机经:题目回忆',
  'faqAnswer2': '(2)在考真题与跟TPO都是完整题目.',
  'faqAnswer3': '(3)在考真题跟考试难度一致,TPO比考试略低',
  'faqAnswer4': '(4)在考真题有可能遇到原题,TPO不可能遇到原题',

  'faqTitle2': '重复的概率大吗?一定能遇到原题吗?确定是原题吗?',
  'faqAnswer5': '(1)官方题库很大，我们只有很小一部分，遇到概率不大主要还是用来练习',
  'faqAnswer6': '(2)群里有很多用户反馈遇到了原题,每月都会反馈遇到了原题',
  'faqAnswer7': '(3)100%原题.您可以先做免费的真题题库.感觉好再买',

  'faqTitle3': '题目有多少套?',
  'faqAnswer8': '(1)套题 49套.阅读单项194套.听力单项100套.口语单项92套.写作单项99套',
  'faqAnswer9': '(2)套题是指:听说读写4个部分组成一套完整套题',
  'faqAnswer10': '(3)阅读单项2篇文章.听力单项5个录音.口语单项4个题目.写作单项2个题目.',
  'faqAnswer11': '(4)注意:套题里面的题目与套题外单项中不重复.',


  'faqTitle4': '题库是什么时候的?适配改革后的吗?',
  'faqAnswer12': '(1)题库是2014-2023年年,网站适配改革后的样式.',
  'faqAnswer13': '(2)阅读2/篇20题,听力5个录音28题,口语4个题目,写作2个题目.',
  'faqAnswer14': '(3)其中口语:1个独立3个综合 写作:一个综合+一个学术讨论.',
  'faqAnswer15': '(4)注意:2014-2019年阅读为14个题目/篇文章.',

  'faqTitle5': '多久更新一次题库?更新到什么时候了?',
  'faqAnswer16': '(1)不定期更新,弄到题库就更新.弄不到就不更新.',
  'faqAnswer17': '(2)真题题库比较难弄.不一定能持续更新,已经持续更新3年多',
  'faqAnswer18': '(3)题库不是每次考完就更新.不可能做到考完就更新.',


  'faqTitle6': '录音质量如何?',
  'faqAnswer19': '(1)题库中的录音质量有非常好的,也有一般的.',
  'faqAnswer20': '(2)非常好的占题库的30-40%左右,一般的占50%左右 ',
  'faqAnswer21': '(3)套题录音非常好.方便大家模考:',

  'faqTitle7': '有答案,范文,原文吗?答案都是正确的吗?',
  'faqAnswer22': '(1)阅读听力无解析,有参考答案.听力有原文,大部分独立口语有范文.综合没有范文.',
  'faqAnswer23': '(2)题库都是特殊渠道获取到的,没有标准答案,所以可能有错误',
  'faqAnswer24': '(3)题库已经经过多轮更新.错误很少了.我们会持续改进.',

  'faqTitle8': '绑定多少台电脑?能不能换电脑?不满意可以退款吗?',
  'faqAnswer25': '(1)买一次最多绑定2台电脑.绑定以后不能换电脑.不能注销.',
  'faqAnswer26': '(2)不支持退款,请先试用,满意以后再购买',

  'faqTitle9': '题库有效时间多久?',
  'faqAnswer27': '(1)购买后永久有效.绑定电脑,不换电脑永久使用题库免费更新',

  'faqTitle10': '我在国外,可以使用吗?',
  'faqAnswer28': '(1)在任何有网的地方都可以,你可以试用免费的题库没有问题再购买',

  'faqTitle11': '我可以只购买一个单项或者部分题库吗?',
  'faqAnswer29': '(1)不可以.我们买题成本比较高.利润太薄)',


  'Usage suggestions': '使用建议',
  'Pre-exam Sprint difficulty': '考前冲刺难度等级',
  'Exam proximity': '考试接近度',
  'TPO Practice Suggestions': 'TPO练习建议',


  'System Features': '系统功能',
  'Key Features': '主要功能',
  'Descriptions': '说明',
  'Score': '分',
  'Reading. Listening can be graded': '阅读、听力评分',
  'ralsiicb': '阅读听力套题,单项做完即可出分,口语,写作不可以评分',
  
  'Exam Set': '套题',
  'Exams Mock': '套题模考',
  'avlraw': '听说读写完整模考,中间不可以休息,完全模考考试环境',
  
  'General Features': '通用功能',
  'Model Test': '模考',
  'Browsing': '浏览',
  'Exercise': '练习',
  'Report': '报告',
  'imtr2': '单项模考.阅读2篇文章/听力5个录音/口语4个题目/写作2个题目 模考,完成后出测试报告',
  'ipr2': '单项练习.阅读2篇文章/听力5个录音/口语4个题目/写作2个题目 练习.完成后出测试报告',
  'Sequential practice': '顺序练习.题材练习',
  'btqace': '浏览试题,查看解析',
  'sra': '统计报告分析',
  'Sequential': '顺序练习',

  'General Feature': '通用功能',
  'Article Translation': '文章翻译',
  'Title Analysis': '题目解析',
  'Listening Original': '听力原文',
  'Model Recording': '示范录音',
  'Writing Demo': '写作范文 ',
  'aaa55': '1-75题库中,55以后所有文章无翻译,无解析,无范文,无示范录音',
  'nafar': '所有真题都没有解析,所有真题听力有原文,无范文,无示范录音',
  
  'Other Features': '其他功能',
  'Favourite Function': '收藏功能',
  'Wrong Question Function': '错题功能',
  'Word Book': '单词本',
  'Sentence Book': '句子本',
  'Article Skipping': '文章跳题',
  'Recording Multiplication': '录音倍速',
  'Recording Jump': '录音跳转',
  'Recording Replay': '录音重播',
  'Spoken Word Recording': '口语重录',
  'Progress Curve': '进步曲线',
  'yHistory': '历史记录',
  'fwqba': '收藏/错题,收藏文章,收藏录音,收藏题目,阅读错题,听力错题',
  'wbsbaw': '单词本/句子本:添加单词到单词本,添加句子到句子本',
  'ajjtat': '文章跳题:任意跳转到任何题目',
  'rsmrs': '录音倍速:多种录音倍速播放',
  'pcycat': '进步曲线:会员中心可以看到阅读,听力分数进度曲线',
  'hycdtq': '历史记录:题目可以多次做题,每次都会保存做题记录',
  'VIP & Normal': 'VIP与普通的区别?',
  'Dear User': '亲爱的用户',
  'You are already VIP': '您已是VIP会员',
  'All questions': '已经拥有',
  'allquestions': '全部VIP题库',
  'Free Updates': '后续免费',
  'freeupdates': '更新题库',
  'Other being': '其他VIP权限',
  'updated': '陆续更新中',

  
  //router name
  'MockRouter': '套题模考',
  'ToeflRouter': '托福',
  'MockExamRouter': '在考真题套题模考',
  '': '',
  '': '',
  
  
  
  'before': '前',
  'after': '后',
  'Reformed': '改革后',
  'Previous': '上一页',
  'Next': '下一页',

  '3-4 Articles  12-14  Ques/Article': '3-4 篇文章每篇文章12-14个题',
  '60-80 min  May be Additional Tests': '60-80 分钟可能有加试',
  '10 minutes break': '休息10分钟',
  '3-4 Articles  10  Ques/Article': '3-4篇文章每篇文章10个题',
  '54-72min  May be Additional Tests': '54-72分钟可能有加试',
  '2 Articles  10  Ques/Article': '2篇文章 每篇文章10个题',
  'min': '分钟',
  'Cancel Additional': '取消加试',
  'Cancel break': '取消休息',
  '2-3 conversation 5 Ques/Record': '2-3对话，每个5个问题',
  '4-6 lectures 6 Ques/Record': '4-6 讲座，每个6个问题',
  'minutes': '分钟',
  'add to an examination': '可能有加试',
  'lectures 6 Ques/Record': '讲座,每 6个问题',
  '2 Conversation 5 Ques/Record': '2对话,每个5个问题',
  'CancelAdditional': '无加试(2个Section)',
  '6 tasks(2 Indepe +4Integ)': '6 道试题 ( 2 独立口语 +4 综合口语)',
  'Tasks': '道试题',
  'Indepe': '独立口语',
  'IntegSpeaking': '综合口语',
  'IntegWriting': '综合写作',
  'IndepeWriting': '学术写作',
  'independent writing': '独立写作',
  'to': '至',



  'dictationAndReading': '听写跟读',

  'WS': '韦氏高阶',
  'KLSFY': '',
  'KLS': '柯林斯',
  'NJ': '牛津',
  'KLSFY': '发音',
  'LG': 'LGS',

  'CustomerServices': '联系客服',
  'help': '帮助',

  'ReadStatistics': '阅读统计',
  'ListenStatistics': '听力统计',
  'TotalCount': '总题目',
  'Right': '正确率',
  'Wrong': '错误数',
  'NotAnswered': '未回答',
  'Part': '考试部分',
  'TotalExamTime': '系统总时间',
  'MyTotaltime': '我的总时间',
  'TotalNumber': '总题目数量',
  'AverageAnswerTime': '平均',
  '': '',
  '': '',
  '': '',

}



// WEBPACK FOOTER //
// ./src/i18n/zh-CN/index.js